module.exports = __webpack_public_path__ + "static/media/400099_01.d78cdb75.png";